/** Past planned work older than this is escalated (banner + bell). */
export const STALE_PROVISIONAL_DAYS = 14;

export function calendarDaysBetween(fromIso: string, toIso: string): number {
  const a = Date.parse(`${fromIso.slice(0, 10)}T12:00:00Z`);
  const b = Date.parse(`${toIso.slice(0, 10)}T12:00:00Z`);
  if (!Number.isFinite(a) || !Number.isFinite(b)) return 0;
  return Math.round((b - a) / 86_400_000);
}

/** True when work_date is at least 14 calendar days before today. */
export function isStaleProvisional(
  workDate: string,
  todayIso: string,
): boolean {
  return calendarDaysBetween(workDate, todayIso) >= STALE_PROVISIONAL_DAYS;
}

export function splitProvisionalByAge<T extends { work_date: string }>(
  jobs: T[],
  todayIso: string,
): { recent: T[]; stale: T[] } {
  const recent: T[] = [];
  const stale: T[] = [];
  for (const job of jobs) {
    if (isStaleProvisional(job.work_date, todayIso)) stale.push(job);
    else recent.push(job);
  }
  return { recent, stale };
}
